import { TempeFabricationPublicServiceException as __BaseException } from "../models/TempeFabricationPublicServiceException";
import { InvalidAddressException, InvalidInput, NoSuchResource, ProductUnavailable, ValidationException, } from "../models/models_0";
import { loadRestJsonErrorCode, parseJsonBody as parseBody, parseJsonErrorBody as parseErrorBody, } from "@aws-sdk/core";
import { requestBuilder as rb } from "@smithy/core";
import { decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectInt32 as __expectInt32, expectLong as __expectLong, expectNonNull as __expectNonNull, expectObject as __expectObject, expectString as __expectString, limitedParseDouble as __limitedParseDouble, serializeFloat as __serializeFloat, _json, collectBody, map, take, withBaseException, } from "@smithy/smithy-client";
export const se_CancelPaymentIntentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/payments/intent/{id}");
    b.p('id', () => input.id, '{id}', false);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_CreateAttributionCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/attribution/event");
    let body;
    body = JSON.stringify(take(input, {
        'eventType': [],
        'products': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_CreateEmailNotificationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/notifications/email");
    let body;
    body = JSON.stringify(take(input, {
        'additionalInformation': _ => _json(_),
        'message': [],
        'senderEmail': [],
        'senderName': [],
        'senderPhone': [],
        'subject': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_CreatePaymentIntentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/payments/intent");
    let body;
    body = JSON.stringify(take(input, {
        'billingAddress': _ => _json(_),
        'clientId': [],
        'customerName': [],
        'email': [],
        'phone': [],
        'productList': _ => se_InvoicedProductList(_, context),
        'shippingAddress': _ => _json(_),
        'shippingOption': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_FindOrderByShortOrderIdCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/shortOrderId/{shortOrderId}");
    b.p('shortOrderId', () => input.shortOrderId, '{shortOrderId}', false);
    const query = map({
        [_e]: [, __expectNonNull(input[_e], `email`)],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_FindOrdersByEmailCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/email/{email}");
    b.p('email', () => input.email, '{email}', false);
    const query = map({
        [_sZC]: [, __expectNonNull(input[_sZ], `shippingZipcode`)],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetOrderCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/{id}");
    b.p('id', () => input.id, '{id}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetProductCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/products/{id}");
    b.p('id', () => input.id, '{id}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetProductListCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/products");
    const query = map({
        [_l]: [, input[_l]],
        [_nP]: [, input[_nP]],
        [_f]: [, input[_f]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_UpdatePaymentIntentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/payments/intent/{id}");
    b.p('id', () => input.id, '{id}', false);
    let body;
    body = JSON.stringify(take(input, {
        'update': _ => se_PaymentIntentUpdateBody(_, context),
    }));
    b.m("PUT")
        .h(headers)
        .b(body);
    return b.build();
};
export const de_CancelPaymentIntentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'additionalFee': __limitedParseDouble,
        'clientSecretId': __expectString,
        'discount': __limitedParseDouble,
        'estimatedTax': __limitedParseDouble,
        'id': __expectString,
        'productSubtotal': __limitedParseDouble,
        'shippingCharge': __limitedParseDouble,
        'shortOrderId': __expectString,
        'total': __limitedParseDouble,
        'ttl': __limitedParseDouble,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_CreateAttributionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'error': __expectString,
        'success': __expectBoolean,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_CreateEmailNotificationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'error': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_CreatePaymentIntentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'additionalFee': __limitedParseDouble,
        'clientSecretId': __expectString,
        'discount': __limitedParseDouble,
        'estimatedTax': __limitedParseDouble,
        'id': __expectString,
        'productSubtotal': __limitedParseDouble,
        'shippingCharge': __limitedParseDouble,
        'shortOrderId': __expectString,
        'total': __limitedParseDouble,
        'ttl': __limitedParseDouble,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_FindOrderByShortOrderIdCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'error': __expectString,
        'result': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_FindOrdersByEmailCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'error': __expectString,
        'results': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetOrderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'error': __expectString,
        'result': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetProductCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'error': __expectString,
        'result': _ => de_Product(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetProductListCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'error': __expectString,
        'exclusiveStartKey': __expectString,
        'results': _ => de_ProductResultList(_, context),
        'totalItems': __expectLong,
        'totalPages': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_UpdatePaymentIntentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'additionalFee': __limitedParseDouble,
        'clientSecretId': __expectString,
        'discount': __limitedParseDouble,
        'estimatedTax': __limitedParseDouble,
        'id': __expectString,
        'productSubtotal': __limitedParseDouble,
        'shippingCharge': __limitedParseDouble,
        'shortOrderId': __expectString,
        'total': __limitedParseDouble,
        'ttl': __limitedParseDouble,
    });
    Object.assign(contents, doc);
    return contents;
};
const de_CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InvalidInput":
        case "com.tempefab.admin.model#InvalidInput":
            throw await de_InvalidInputRes(parsedOutput, context);
        case "ProductUnavailable":
        case "com.tempefab.admin.model#ProductUnavailable":
            throw await de_ProductUnavailableRes(parsedOutput, context);
        case "ValidationException":
        case "smithy.framework#ValidationException":
            throw await de_ValidationExceptionRes(parsedOutput, context);
        case "InvalidAddressException":
        case "com.tempefab.admin.model#InvalidAddressException":
            throw await de_InvalidAddressExceptionRes(parsedOutput, context);
        case "NoSuchResource":
        case "com.tempefab.admin.model#NoSuchResource":
            throw await de_NoSuchResourceRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return throwDefaultError({
                output,
                parsedBody,
                errorCode
            });
    }
};
const throwDefaultError = withBaseException(__BaseException);
const de_InvalidAddressExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'error': __expectString,
        'possibleAddresses': _json,
    });
    Object.assign(contents, doc);
    const exception = new InvalidAddressException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_InvalidInputRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'error': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new InvalidInput({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_NoSuchResourceRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'resource': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new NoSuchResource({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_ProductUnavailableRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'error': __expectString,
        'productId': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new ProductUnavailable({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_ValidationExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'fieldList': _json,
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new ValidationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const se_InvoicedProduct = (input, context) => {
    return take(input, {
        'customization': _ => se_ProductCustomizationOption(_, context),
        'name': [],
        'price': __serializeFloat,
        'productId': [],
        'quantity': [],
        'sku': [],
        'total': __serializeFloat,
    });
};
const se_InvoicedProductList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_InvoicedProduct(entry, context);
    });
};
const se_PaymentIntentUpdateBody = (input, context) => {
    return take(input, {
        'billingAddress': _json,
        'clientId': [],
        'customerName': [],
        'email': [],
        'phone': [],
        'productList': _ => se_InvoicedProductList(_, context),
        'shippingAddress': _json,
        'shippingOption': [],
    });
};
const se_ProductCustomizationOption = (input, context) => {
    return take(input, {
        'additionalCost': __serializeFloat,
        'name': [],
        'sku': [],
    });
};
const de_Product = (output, context) => {
    return take(output, {
        'category': __expectString,
        'createdAt': __expectString,
        'customization': (_) => de_ProductCustomizationList(_, context),
        'description': __expectString,
        'features': _json,
        'id': __expectString,
        'inventory': __expectInt32,
        'keyImage': __expectString,
        'name': __expectString,
        'otherImages': _json,
        'price': __limitedParseDouble,
        'productAttributes': _json,
        'sale': (_) => de_Sale(_, context),
        'shipping': (_) => de_ProductShipping(_, context),
        'shippingOptions': (_) => de_ShippingOptionList(_, context),
        'sku': __expectString,
        'status': __expectString,
        'updatedAt': __expectString,
    });
};
const de_ProductCustomization = (output, context) => {
    return take(output, {
        'key': __expectString,
        'possibleValues': (_) => de_ProductCustomizationOptionList(_, context),
    });
};
const de_ProductCustomizationList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_ProductCustomization(entry, context);
    });
    return retVal;
};
const de_ProductCustomizationOption = (output, context) => {
    return take(output, {
        'additionalCost': __limitedParseDouble,
        'name': __expectString,
        'sku': __expectString,
    });
};
const de_ProductCustomizationOptionList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_ProductCustomizationOption(entry, context);
    });
    return retVal;
};
const de_ProductResultList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Product(entry, context);
    });
    return retVal;
};
const de_ProductShipping = (output, context) => {
    return take(output, {
        'depth': __limitedParseDouble,
        'dimensionUnit': __expectString,
        'height': __limitedParseDouble,
        'weight': __limitedParseDouble,
        'weightUnit': __expectString,
        'width': __limitedParseDouble,
    });
};
const de_Sale = (output, context) => {
    return take(output, {
        'discount': __limitedParseDouble,
        'type': __expectString,
    });
};
const de_ShippingOption = (output, context) => {
    return take(output, {
        'cost': __limitedParseDouble,
        'deliveryPromise': __expectString,
        'type': __expectString,
    });
};
const de_ShippingOptionList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_ShippingOption(entry, context);
    });
    return retVal;
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then(body => context.utf8Encoder(body));
const _e = "email";
const _f = "filter";
const _l = "limit";
const _nP = "nextPage";
const _sZ = "shippingZipcode";
const _sZC = "shippingZipCode";
